import { render, staticRenderFns } from "./TypeRow.vue?vue&type=template&id=2b64b4d0&"
import script from "./TypeRow.vue?vue&type=script&lang=js&"
export * from "./TypeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports